var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('img',{staticClass:"order-status-image",attrs:{"src":_vm.orderStatusGifs[_vm.status],"alt":_vm.status}})])}
var staticRenderFns = []

export { render, staticRenderFns }